import React, { useState, useEffect } from "react";
import { Select, Button, message, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import request from "helper/request";

const { Option } = Select;

const LocationSelector = ({
  value,
  onChange,
  placeholder = "Select a saved location",
  allowAddNew = true,
  ...props
}) => {
  const [savedLocations, setSavedLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  // Load saved locations on mount
  useEffect(() => {
    loadSavedLocations();
  }, []);

  const loadSavedLocations = async () => {
    setLoading(true);
    try {
      const response = await request.get("/saved-locations/all-locations", {
        params: {
          page: 1,
          pageSize: 100 // Get a large number to show all locations
        }
      });

      console.log("📍 LocationSelector - API response:", response);
      console.log("📍 LocationSelector - Data array:", response?.data);
      console.log("📍 LocationSelector - First location:", response?.data?.[0]);
      console.log(
        "📍 LocationSelector - First location image:",
        response?.data?.[0]?.image
      );

      if (response?.data) {
        setSavedLocations(response.data);
      }
    } catch (error) {
      console.error("Failed to load saved locations:", error);
      message.error("Failed to load saved locations");
    } finally {
      setLoading(false);
    }
  };

  const handleLocationSelect = (locationId) => {
    const selectedLocation = savedLocations.find((loc) => loc.id === locationId);
    if (selectedLocation && onChange) {
      // Pass the full location data to the parent
      onChange({
        id: selectedLocation.id,
        locationName: selectedLocation.locationName,
        address: selectedLocation.address || selectedLocation.descriptiveAddress,
        lat: selectedLocation.lat,
        lng: selectedLocation.lng,
        image: selectedLocation.image, // Include the image URL
        // Provide fallback address fields for compatibility
        city: selectedLocation.city || "",
        state: selectedLocation.state || "",
        zipCode: selectedLocation.zipCode || ""
      });
    }
  };

  const handleAddNewLocation = () => {
    // Navigate to add new location page
    history.push("/locations/new");
  };

  const renderLocationOption = (location) => {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        {location.image ? (
          <img
            src={location.image}
            alt={location.locationName}
            style={{
              width: "40px",
              height: "40px",
              objectFit: "cover",
              borderRadius: "4px",
              border: "1px solid #d9d9d9",
              flexShrink: 0
            }}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        ) : (
          <div
            style={{
              width: "40px",
              height: "40px",
              backgroundColor: "#f0f0f0",
              borderRadius: "4px",
              border: "1px solid #d9d9d9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "20px",
              flexShrink: 0
            }}
          >
            📍
          </div>
        )}
        <div style={{ flex: 1, overflow: "hidden" }}>
          <div style={{ fontWeight: 500 }}>{location.locationName}</div>
          <div
            style={{
              fontSize: "12px",
              color: "#666",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {location.address || location.descriptiveAddress}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="location-selector">
      <Select
        value={value?.id}
        placeholder={placeholder}
        onSelect={handleLocationSelect}
        loading={loading}
        showSearch
        allowClear
        filterOption={(input, option) => {
          const location = savedLocations.find((loc) => loc.id === option.value);
          if (!location) return false;
          const searchText = input.toLowerCase();
          return (
            location.locationName?.toLowerCase().includes(searchText) ||
            location.address?.toLowerCase().includes(searchText) ||
            location.descriptiveAddress?.toLowerCase().includes(searchText)
          );
        }}
        style={{ width: "100%" }}
        {...props}
      >
        {savedLocations.map((location) => (
          <Option key={location.id} value={location.id}>
            {renderLocationOption(location)}
          </Option>
        ))}
      </Select>

      {allowAddNew && (
        <Button
          type="dashed"
          icon={<PlusOutlined />}
          onClick={handleAddNewLocation}
          style={{
            width: "100%",
            marginTop: "8px",
            borderColor: "#d9d9d9",
            color: "#666"
          }}
        >
          Add New Location
        </Button>
      )}
    </div>
  );
};

export default LocationSelector;
